import { VProgressLinear } from 'vuetify/lib'
//    <UserFlow :user_flow="user_flow" />
import UserFlow from '@/views/components/flow/user_flow.vue'
import {THRID} from './constants'
import GatheringInfo from './GatheringInfo'
import LawWorks from './LawWorks'
import OpenShopInfor from './OpenShopInfor'
import SupplementaryInfo from './SupplementaryInfo'
import TaxWorks from '@/views/openShopApply/TaxWorks.jsx'
import styles from './index.module.less'
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        target: {
            type: Object,
            default: () => null
        },
        loading: {
            type: Boolean,
            default: () => false
        },
        entryType: {
            type: String,
        }
    },
    
    data() {
        return {
             //  target: null,
             //  loading: false
        }
    },
    created() {
       
    },
    render() {
        const _this = this
        return <div class={styles['expand-contain']}>
          {_this.loading && <VProgressLinear indeterminate/>} 
          {_this.target && !_this.loading && <div class={styles['card-contain']}>

           <div class={styles['card-contain-child']}>
              <OpenShopInfor
                target = {_this.target}
                entryType ={_this.entryType}
              />
            
          </div>
          <div class={styles['card-contain-child']}>
            <GatheringInfo
                target = {_this.target}
                entryType ={_this.entryType}
            />
          </div>
          <div class={styles['card-contain-child']}>
             <LawWorks target = {_this.target}/>
             <div style="margin-top:10px">
                <TaxWorks
                    target = {_this.target}
                />   
             </div>
          </div>
          {/* <div class={styles['card-contain-child']}>
            <TaxWorks
                target = {_this.target}
            />
          </div> */}
          { this.entryType !== THRID && <div class={styles['card-contain-child']}> <SupplementaryInfo target = {_this.target}/></div>}
          { this.entryType !== THRID && <div class={styles['card-contain-child']}> <UserFlow user_flow = {_this.target.user_flow}/></div>}
          </div>}
    </div>
    }
}